import React, { useState, useEffect } from "react";
import ApiService from './memberApiServices';
import { useSession } from "hooks/useSession";
import { fetchWrapper,  } from "utils/apiFetch";
import { showMainToast } from "utils/showToast";
import PermissionManager from "./components/PermissonManagerComponent";
import { useNavigate } from "react-router";

function MemberSettingManagement() {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [schemeLoading, setSchemeLoading] = useState(false); // ✅ separate scheme loading
    const [formLoading, setFormLoading] = useState({});
    const [errors, setErrors] = useState({});
    const {userid,name,role} = useSession();
    const [getOtp,setgetOtp]= useState(false);
    const [schemeData, getSchemeData] = useState([])
    const query = new URLSearchParams(window.location.search);
    const urlUserId = query.get('userid');
    const effectiveUserId = urlUserId ? urlUserId : userid;
    const [nrole, setRole] = useState("");
    const [members, setMembers] = useState([]);
    const [search, setSearch] = useState("");
    const [filtered, setFiltered] = useState([]);
    const [selectedMember, setSelectedMember] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [permissionMemberId, setPermissionMemberId] = useState(null);
    const [selectedTxnType, setSelectedTxnType] = useState("");
    // ✅ dataVersion increments after every successful save to force form remount
    const [dataVersion, setDataVersion] = useState(0);
    const [selectedWalletAction, setSelectedWalletAction] = useState("");
    const [walletActionWalletType, setWalletActionWalletType] = useState("WALLET");

    // Generic validation helper
    const validateField = (name, value, rules) => {
        const fieldErrors = [];
        
        if (rules.required && (!value || value.toString().trim() === '')) {
            fieldErrors.push(`${name} is required`);
        }
        if (rules.minLength && value && value.length < rules.minLength) {
            fieldErrors.push(`${name} must be at least ${rules.minLength} characters`);
        }
        if (rules.email && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            fieldErrors.push('Please enter a valid email address');
        }
        if (rules.phone && value && !/^[0-9]{10}$/.test(value.replace(/\D/g, ''))) {
            fieldErrors.push('Please enter a valid phone number');
        }
        if (rules.pattern && value && !rules.pattern.test(value)) {
            fieldErrors.push(rules.patternMessage || `${name} format is invalid`);
        }
        return fieldErrors;
    };

    const options = members.map(m => ({
        value: m.id,
        label: `${m.name} (${m.mobile})`
    }));

    const fetchMembers = async (role) => {
        const formData = new FormData();
        formData.append("role", role);
        const res = await ApiService.getUsersByRole(formData);
        if (res.status) {
            setMembers(res.data);
            setFiltered(res.data);
        }
    };

    const handleRoleChange = (e) => {
        const value = e.target.value;
        setRole(value);
        setSelectedMember(null);
        setSearch("");
        fetchMembers(value);
    };

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearch(value);
        setShowDropdown(true);
        const filteredList = members.filter(m =>
            m.name.toLowerCase().includes(value.toLowerCase()) ||
            m.mobile.includes(value)
        );
        setFiltered(filteredList);
    };

    const handleSelect = (member) => {
        setSelectedMember(member.id);
        setSearch(`${member.name} (${member.mobile})`);
        setShowDropdown(false);
    };

    const setFormLoadingState = (formName, isLoading) => {
        setFormLoading(prev => ({ ...prev, [formName]: isLoading }));
    };

    const setFormErrors = (formName, formErrors) => {
        setErrors(prev => ({ ...prev, [formName]: formErrors }));
    };

    const fetchData = async () => {
        try {
            setLoading(true);
            const url = `https://api.mokshiq.in/get_user_profile?user=${effectiveUserId}`;
            const response = await fetchWrapper(url);
            setData(response.data || {});
        } catch (err) {
            console.error("Error fetching data:", err);
            showMainToast("Failed to load profile data", "danger");
        } finally {
            setLoading(false);
        }
    };

    const getSchemeDataList = async () => {
        try {
            setSchemeLoading(true); // ✅ use separate flag so it doesn't block full-page spinner
            const formData = new FormData()
            formData.append('userid', effectiveUserId);
            formData.append('action', 'GET');
            const url = `https://api.mokshiq.in/scheme_manager_action`;
            const response = await fetchWrapper(url, {method:'POST', body:formData});
            getSchemeData(response.data || {});
        } catch (err) {
            console.error("Error fetching data:", err);
            showMainToast("Failed to load scheme data", "danger");
        } finally {
            setSchemeLoading(false);
        }
    }

   useEffect(() => {
    fetchData();
    getSchemeDataList();
}, [effectiveUserId]); // ← was [], so it never re-ran on user change

    const sendOTP = async (e) => {   
        e.preventDefault();  
        try {
            const url = `https://api.mokshiq.in/get_otp?userid=${effectiveUserId}`;
            const response = await fetchWrapper(url);
            if(response.status){
                setgetOtp(true)
                showMainToast("OTP Sent Successfully", "success");
            } else {
                setgetOtp(false);
                showMainToast("something went wrong!..", "danger");
            }
        } catch (err) {
            showMainToast("Failed to load profile data", "danger");
        }
    };

    // Profile Update Handler
    const handleProfileUpdate = async (e) => {
        e.preventDefault();
        const formName = 'profile';
        setFormLoadingState(formName, true);
        const form = e.target;
        const formData = new FormData(form);
        const validationRules = {
            name: { required: true, minLength: 2 },
            email: { required: true, email: true },
            mobile: { required: true, phone: true },
            address: { required: true },
            city: { required: true },
            state: { required: true },
            pin_code: { required: true, pattern: /^\d{6}$/, patternMessage: 'Pincode must be 6 digits' }
        };
        const formErrors = {};
        Object.keys(validationRules).forEach(field => {
            const value = formData.get(field);
            const fieldErrors = validateField(field, value, validationRules[field]);
            if (fieldErrors.length > 0) formErrors[field] = fieldErrors;
        });
        if (Object.keys(formErrors).length > 0) {
            setFormErrors(formName, formErrors);
            setFormLoadingState(formName, false);
            showMainToast("Please fix validation errors", "danger");
            return;
        }
        try {
            const response = await ApiService.updateProfile(formData);
            if(response.status){
                showMainToast(response.message || "Profile updated successfully!", "success");
                setFormErrors(formName, {});
                await fetchData();
                setDataVersion(v => v + 1); // ✅ force form remount with fresh data
            } else {
                showMainToast(response.message || "Profile not updated", "danger");
            }
        } catch (error) {
            showMainToast("Failed to update profile", "danger");
        } finally {
            setFormLoadingState(formName, false);
        }
    };

    // KYC Update Handler
    const handleKycUpdate = async (e) => {
        e.preventDefault();
        const formName = 'kyc';
        setFormLoadingState(formName, true);
        const form = e.target;
        const formData = new FormData(form);
        const validationRules = {
            shop_name: { required: true },
            gstin: { required: true, pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/, patternMessage: 'Please enter valid GST number' },
            pan_card: { required: true, pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, patternMessage: 'Please enter valid PAN number' },
            aadhar_card: { required: true, pattern: /^\d{12}$/, patternMessage: 'Aadhar number must be 12 digits' }
        };
        const formErrors = {};
        Object.keys(validationRules).forEach(field => {
            const value = formData.get(field);
            const fieldErrors = validateField(field, value, validationRules[field]);
            if (fieldErrors.length > 0) formErrors[field] = fieldErrors;
        });
        if (Object.keys(formErrors).length > 0) {
            setFormErrors(formName, formErrors);
            setFormLoadingState(formName, false);
            showMainToast("Please fix validation errors", "danger");
            return;
        }
        formData.append("id", effectiveUserId);
        formData.append("action", "kyc_update");
        try {
            const response = await ApiService.updateKyc(formData);
            if(response.status){
                showMainToast(response.message || "KYC updated successfully!", "success");
                setFormErrors(formName, {});
                await fetchData();
                setDataVersion(v => v + 1); // ✅ force form remount
            } else {
                showMainToast(response.message || "KYC not updated", "danger");
            }
        } catch (error) {
            showMainToast("Failed to update KYC details", "danger");
        } finally {
            setFormLoadingState(formName, false);
        }
    };

    // Password Change Handler
    const handlePasswordChange = async (e) => {
        e.preventDefault();
        const formName = 'password';
        setFormLoadingState(formName, true);
        const form = e.target;
        const formData = new FormData(form);
        const currentPassword = form.current_password.value;
        const newPassword = form.password.value;
        const confirmPassword = form.confirm_password.value;
        const formErrors = {};
        if (!currentPassword) formErrors.current_password = ['Current password is required'];
        if (!newPassword) formErrors.password = ['New password is required'];
        if (newPassword && newPassword.length < 8) formErrors.password = ['Password must be at least 8 characters'];
        if (!confirmPassword) formErrors.confirm_password = ['Confirm password is required'];
        if (newPassword && confirmPassword && newPassword !== confirmPassword) {
            formErrors.confirm_password = ['Passwords do not match'];
        }
        if (Object.keys(formErrors).length > 0) {
            setFormErrors(formName, formErrors);
            setFormLoadingState(formName, false);
            showMainToast("Please fix validation errors", "danger");
            return;
        }
        try {
            const response = await ApiService.changePassword(formData);
            if(response.status){
                showMainToast(response.message || "Password updated successfully!", "success");
                setFormErrors(formName, {});
                form.reset();
            } else {
                showMainToast(response.message || "password not updated", "danger");
            }
        } catch (error) {
            showMainToast("Failed to change password", "danger");
        } finally {
            setFormLoadingState(formName, false);
        }
    };

    // PIN Change Handler
    const handlePinChange = async (e) => {
        e.preventDefault();
        const formName = 'pin';
        setFormLoadingState(formName, true);
        const form = e.target;
        const newPin = form.new_pin.value;
        const confirmPin = form.confirm_pin.value;
        const otp = form.otp.value;
        const formErrors = {};
        if (!newPin) formErrors.new_pin = ['New PIN is required'];
        if (newPin && !/^\d{4,6}$/.test(newPin)) formErrors.new_pin = ['PIN must be 4-6 digits'];
        if (!confirmPin) formErrors.confirm_pin = ['Confirm PIN is required'];
        if (newPin && confirmPin && newPin !== confirmPin) {
            formErrors.confirm_pin = ['PINs do not match'];
        }
        if (!otp) formErrors.otp = ['OTP is required'];
        if (Object.keys(formErrors).length > 0) {
            setFormErrors(formName, formErrors);
            setFormLoadingState(formName, false);
            showMainToast("Please fix validation errors", "danger");
            return;
        }
        try {
            const formData = new FormData();
            formData.append('otp_pin', newPin);
            formData.append('otp', otp);
            formData.append('user_id', effectiveUserId);
            const response = await ApiService.changePin(formData);
            if(response.status){
                showMainToast(response.message || "Pin updated successfully!", "success");
                setFormErrors(formName, {});
                form.reset();
            } else {
                showMainToast(response.message || "pin not updated", "danger");
            }
        } catch (error) {
            showMainToast("Failed to change PIN", "danger");
        } finally {
            setFormLoadingState(formName, false);
        }
    };

    // Bank Details Handler
    const handleBankDetailsUpdate = async (e) => {
        e.preventDefault();
        const formName = 'bank';
        setFormLoadingState(formName, true);
        const form = e.target;
        const formData = new FormData(form);
        const accountNumber = form.account_number.value;
        const bankName = form.bank_name.value;
        const ifscCode = form.bank_ifsc.value;
        const formErrors = {};
        if (!accountNumber) formErrors.account_number = ['Account number is required'];
        if (accountNumber && !/^\d{9,18}$/.test(accountNumber)) formErrors.account_number = ['Account number must be 9-18 digits'];
        if (!bankName) formErrors.bank_name = ['Bank name is required'];
        if (!ifscCode) formErrors.bank_ifsc = ['IFSC code is required'];
        if (ifscCode && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifscCode)) formErrors.bank_ifsc = ['Please enter valid IFSC code'];
        if (Object.keys(formErrors).length > 0) {
            setFormErrors(formName, formErrors);
            setFormLoadingState(formName, false);
            showMainToast("Please fix validation errors", "danger");
            return;
        }
        try {
            const response = await ApiService.updateBankDetails(formData);
            if(response.status){
                showMainToast(response.message || "Bank details updated successfully!", "success");
                setFormErrors(formName, {});
                await fetchData();
                setDataVersion(v => v + 1); // ✅ force form remount
            } else {
                showMainToast(response.message || "Bank details not updated", "danger");
            }
        } catch (error) {
            showMainToast("Failed to update bank details", "danger");
        } finally {
            setFormLoadingState(formName, false);
        }
    };

    // Role Assignment Handler
    const handleRoleAssignment = async (e) => {
        e.preventDefault();
        const formName = 'role';
        setFormLoadingState(formName, true);
        const form = e.target;
        const role = form.role.value;
        if (!role) {
            setFormErrors(formName, { role: ['Please select a role'] });
            setFormLoadingState(formName, false);
            showMainToast("Please select a role", "danger");
            return;
        }
        try {
            const formData = new FormData();
            formData.append("role_id", role);
            formData.append("user_id", effectiveUserId);
            formData.append("action", "ChangeRole");
            const response = await ApiService.assignRole(formData);
            if(response.status){
                showMainToast("Role assigned successfully!", "success");
                setFormErrors(formName, {});
            } else {
                showMainToast("Something went wrong!..", "danger");
            }
        } catch (error) {
            showMainToast("Failed to assign role", "danger");
        } finally {
            setFormLoadingState(formName, false);
        }
    };

    // Scheme Assignment Handler
    const handleSchemeAssignment = async (e) => {
        e.preventDefault();
        const formName = 'scheme';
        setFormLoadingState(formName, true);
        const form = e.target;
        const role = form.scheme_id.value;
        if (!role) {
            setFormErrors(formName, { role: ['Please select a scheme'] });
            setFormLoadingState(formName, false);
            showMainToast("Please select a scheme", "danger");
            return;
        }
        try {
            const formData = new FormData();
            formData.append('action', 'ChangeScheme');
            formData.append('user_id', effectiveUserId);
            formData.append('scheme_id', role);
            const response = await ApiService.assignScheme(formData);
            if(response.status){
                showMainToast(response.message, "success");
                setFormErrors(formName, {});
            } else {
                showMainToast(response.message, "danger");
            }
        } catch (error) {
            showMainToast("Failed to assign scheme", "danger");
        } finally {
            setFormLoadingState(formName, false);
        }
    };

    const handleWalletAction = async (e) => {
        e.preventDefault();
        const formName = 'walletAction';
        setFormLoadingState(formName, true);
        const form = e.target;
    
        const action = form.wallet_action.value;
        const walletType = form.wallet_type_action.value;
        const amount = form.amount_action.value;
        const remark = form.remark_action.value;
    
        const formErrors = {};
        if (!action) formErrors.wallet_action = ['Please select an action'];
        if (!walletType) formErrors.wallet_type_action = ['Please select wallet type'];
        if (!amount) formErrors.amount_action = ['Amount is required'];
        if (amount && (isNaN(amount) || parseFloat(amount) <= 0))
            formErrors.amount_action = ['Please enter a valid amount'];
        if (!remark) formErrors.remark_action = ['Remark is required'];
    
        if (Object.keys(formErrors).length > 0) {
            setFormErrors(formName, formErrors);
            setFormLoadingState(formName, false);
            showMainToast("Please fix validation errors", "danger");
            return;
        }
    
        try {
            const formData = new FormData();
            formData.append("action", action);
            formData.append("user_id", effectiveUserId);
            formData.append("wallet_type", walletType);
            formData.append("amount", amount);
            formData.append("remark", remark);
    
            const response = await ApiService.fundTransfer(formData);
    
            if (response.status) {
                showMainToast(response.message || `${action} successful!`, "success");
                setFormErrors(formName, {});
                form.reset();
                setSelectedWalletAction("");
                setWalletActionWalletType("WALLET");
                await fetchData();
                setDataVersion(v => v + 1);
            } else {
                showMainToast(response.message || `${action} failed`, "danger");
            }
        } catch (error) {
            showMainToast(`Failed to perform ${action}`, "danger");
        } finally {
            setFormLoadingState(formName, false);
        }
    };

    // Mapping Update Handler
    const handleMappingUpdate = async (e) => {
        e.preventDefault();
        if (!role || !selectedMember) {
            showMainToast("Select role and member", "danger");
            return;
        }
        try {
            const formData = new FormData();
            formData.append("user_id", effectiveUserId);
            formData.append("member_id", selectedMember);
            formData.append("role", nrole);
            const res = await ApiService.updateUserMapping(formData);
            if (res?.status) {
                showMainToast(res?.message || "Mapping updated", "success");
            } else {
                showMainToast(res?.message || "Update failed", "danger");
            }
        } catch (err) {
            console.error("Mapping Error:", err);
            showMainToast("Something went wrong", "danger");
        }
    };

    // KYC Status Update Handler
    const handleKycStatusUpdate = async (e) => {
        e.preventDefault();
        const formName = 'kycStatus';
        setFormLoadingState(formName, true);
        const form = e.target;
        const formData = new FormData(form);
        const kycStatus = form.kyc_status.value;
        const userStatus = form.user_status.value;
        const remarks = form.remark.value;
        const formErrors = {};
        if (!kycStatus) formErrors.kyc_status = ['Please select KYC status'];
        if (!userStatus) formErrors.user_status = ['Please select user status'];
        if (!remarks) formErrors.remark = ['Remarks are required'];
        if (Object.keys(formErrors).length > 0) {
            setFormErrors(formName, formErrors);
            setFormLoadingState(formName, false);
            showMainToast("Please fix validation errors", "danger");
            return;
        }
        try {
            const response = await ApiService.updateKycStatus(formData);
            if (response?.status) {
                showMainToast(response?.message || "KYC status updated", "success");
                setFormErrors(formName, {});
            } else {
                showMainToast(response?.message || "Update failed", "danger");
            }
        } catch (error) {
            showMainToast("Failed to update KYC status", "danger");
        } finally {
            setFormLoadingState(formName, false);
        }
    };

    const handlelogut = () => {
        localStorage.clear();
    }

    // Fund Transfer Handler
    const handleFundTransfer = async (e) => {
        e.preventDefault();
        const formName = 'fundTransfer';
        setFormLoadingState(formName, true);
        const form = e.target;
        const formData = new FormData(form);
        const transactionType = form.transaction_type.value;
        const amount = form.amount.value;
        const transactionPin = form.transaction_pin.value;
        const remarks = form.remarks.value;
        const walletType = form.wallet_type?.value;
        const formErrors = {};
        if (!transactionType) formErrors.transaction_type = ['Please select transaction type'];
        if (!amount) formErrors.amount = ['Amount is required'];
        if (amount && (isNaN(amount) || parseFloat(amount) <= 0)) formErrors.amount = ['Please enter valid amount'];
        if (!transactionPin) formErrors.transaction_pin = ['Transaction PIN is required'];
        if (transactionPin && !/^\d{4,6}$/.test(transactionPin)) formErrors.transaction_pin = ['PIN must be 4-6 digits'];
        if (!remarks) formErrors.remarks = ['Remarks are required'];
        if (transactionType === "RETURN" && walletType && !["MAIN", "CREDIT"].includes(walletType)) {
            formErrors.wallet_type = ['Please select a valid return type'];
        }
        if (Object.keys(formErrors).length > 0) {
            setFormErrors(formName, formErrors);
            setFormLoadingState(formName, false);
            showMainToast("Please fix validation errors", "danger");
            return;
        }
        try {
            const payload = new FormData();
            payload.append("action", "FUNDTNDR");
            payload.append("ttype", transactionType);
            payload.append("amount", amount);
            payload.append("remark", remarks);
            payload.append("user_id", effectiveUserId);
            payload.append("transaction_pin", transactionPin);
           
            payload.append("wallet_type", walletType);
            
            const response = await ApiService.fundTransfer(payload);
            if (response.status) {
                setFormErrors(formName, {});
                form.reset();
                setSelectedTxnType("");
                showMainToast(response.message, "success");
                await fetchData(); // ✅ refresh wallet balances after transfer
                setDataVersion(v => v + 1);
            } else {
                showMainToast(response.message, "danger");
            }
        } catch (error) {
            showMainToast("Failed to initiate fund transfer", "danger");
        } finally {
            setFormLoadingState(formName, false);
        }
    };

    const navigate = useNavigate();

    const getErrorMessage = (formName, fieldName) => {
        return errors[formName]?.[fieldName]?.[0] || '';
    };

    const isFormLoading = (formName) => {
        return formLoading[formName] || false;
    };

    if (loading) {
        return <p>Loading user profile...</p>;
    }

    return (
        <main>
            <div className="container-fluid">
               <div className="row m-1">
  <div className="col-12 d-flex justify-content-between align-items-start flex-wrap">
    <div>
      <h4 className="main-title">Settings</h4>
      <ul className="app-line-breadcrumbs mb-3">
        <li>
          <a className="f-s-14 f-w-500" href="#">
            <span className="d-flex align-items-center gap-1">
              <i className="ph-duotone ph-gear f-s-16"></i>
              Apps
            </span>
          </a>
        </li>
        <li>
          <a className="f-s-14 f-w-500" href="#">Profile</a>
        </li>
        <li className="active">
          <span className="f-s-14 f-w-500">Settings</span>
        </li>
      </ul>
    </div>
    <div className="mt-1">
      <button className="btn btn-primary" onClick={() => navigate(`/member_details/${effectiveUserId}`)}>
        <i className="ph-duotone ph-user-check me-1"></i>
        Check Member Setting
      </button>
    </div>
  </div>
</div>

                <div className="row">
                    <div className="col-lg-4 col-xxl-3">
                        <div className="card">
                            <div className="card-header">
                                <h5>Settings</h5>
                            </div>
                            <div className="card-body">
                                <div className="vertical-tab setting-tab">
                                    <ul className="nav nav-tabs tab-light-primary " id="v-bg" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button aria-controls="profile-tab-pane" aria-selected="true"
                                                className="nav-link active" data-bs-target="#profile-tab-pane"
                                                data-bs-toggle="tab" id="profile-tab" role="tab"
                                                type="button"><i
                                                    className="ph-bold  ph-user-circle-gear pe-2"></i>
                                                Profile Details
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button aria-controls="activity-tab-pane" aria-selected="true"
                                                className="nav-link"
                                                data-bs-target="#activity-tab-pane" data-bs-toggle="tab"
                                                id="activity-tab"
                                                role="tab" type="button"><i
                                                    className="ph-bold  ph-alarm pe-2"></i>
                                                KYC Details
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button aria-controls="security-tab-pane" aria-selected="false"
                                                className="nav-link"
                                                data-bs-target="#security-tab-pane" data-bs-toggle="tab"
                                                id="security-tab"
                                                role="tab" type="button"><i
                                                    className="ph-bold  ph-shield-check pe-2"></i>Password Manager
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button aria-controls="privacy-tab-pane" aria-selected="false"
                                                className="nav-link"
                                                data-bs-target="#privacy-tab-pane" data-bs-toggle="tab"
                                                id="privacy-tab"
                                                role="tab" type="button"><i
                                                    className="ph-bold  ph-lock-open pe-2"></i>PIN Manager
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button aria-controls="subscription-tab-pane" aria-selected="false"
                                                className="nav-link"
                                                data-bs-target="#subscription-tab-pane" data-bs-toggle="tab"
                                                id="subscription-tab"
                                                role="tab" type="button"><i
                                                    className="ph-bold  ph-bell-simple pe-2"></i>Bank Details
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button aria-controls="notification-tab-pane" aria-selected="false"
                                                className="nav-link"
                                                data-bs-target="#notification-tab-pane" data-bs-toggle="tab"
                                                id="notification-tab"
                                                role="tab" type="button"><i
                                                    className="ph-bold  ph-notification pe-2"></i>Notification
                                            </button>
                                        </li>
                                        {( role === "Admin" || role === "Main Admin" || role === "White label") && (
                                         <>
                                        <li className="nav-item" role="presentation">
                                            <button aria-controls="Connection-tab-pane" aria-selected="false"
                                                className="nav-link"
                                                data-bs-target="#Connection-tab-pane" data-bs-toggle="tab"
                                                id="Connection-tab"
                                                role="tab" type="button"><i
                                                    className="ph-bold  ph-graph pe-2"></i>Role Manager
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button aria-controls="mapping-manager-tab-pane" aria-selected="false"
                                                className="nav-link"
                                                data-bs-target="#mapping-manager-tab-pane" data-bs-toggle="tab"
                                                id="mapping-manager-tab"
                                                role="tab" type="button"><i
                                                    className="ph-bold  ph-notification pe-2"></i>Mapping Manager
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button aria-controls="update-kyc-tab-pane" aria-selected="true"
                                                className="nav-link" data-bs-target="#update-kyc-tab-pane"
                                                data-bs-toggle="tab" id="update-kyc-tab" role="tab"
                                                type="button"><i
                                                    className="ph-bold  ph-user-circle-gear pe-2"></i>
                                                Update KYC
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button aria-controls="scheme-manager-tab-pane" aria-selected="true"
                                                className="nav-link"
                                                data-bs-target="#scheme-manager-tab-pane" data-bs-toggle="tab"
                                                id="scheme-manager-tab"
                                                role="tab" type="button"><i
                                                    className="ph-bold  ph-alarm pe-2"></i>
                                                Scheme Manager
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button aria-controls="permission-manager-tab-pane" aria-selected="false"
                                                className="nav-link"
                                                data-bs-target="#permission-manager-tab-pane" data-bs-toggle="tab"
                                                id="permission-manager-tab"
                                                role="tab" type="button"><i
                                                    className="ph-bold  ph-lock-open pe-2"></i>Permission Manager
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button aria-controls="fund-transfer-tab-pane" aria-selected="false"
                                                className="nav-link"
                                                data-bs-target="#fund-transfer-tab-pane" data-bs-toggle="tab"
                                                id="fund-transfer-tab"
                                                role="tab" type="button"><i
                                                    className="ph-bold  ph-bell-simple pe-2"></i>Fund Transfer/Returns
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button aria-controls="wallet-actions-tab-pane" aria-selected="false"
                                                className="nav-link"
                                                data-bs-target="#wallet-actions-tab-pane" data-bs-toggle="tab"
                                                id="wallet-actions-tab"
                                                role="tab" type="button">
                                                <i className="ph-bold ph-scales pe-2"></i>
                                                Wallet Actions
                                            </button>
                                        </li>
                                        </>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <div className="card hover-effect card-light-primary mt-4">
                                    <div className="card-body">
                                        <h5>Used space</h5>
                                        <p className="mt-2 text-secondary f-s-16">Your team has used 80% of your
                                            available space.need more?</p>
                                        <div aria-valuemax="100" aria-valuemin="0"
                                            aria-valuenow="0" className="progress w-100 mt-3 mb-3" role="progressbar">
                                            <div className="progress-bar bg-primary progress-bar-striped"
                                                style={{ width: '78.5%' }}></div>
                                        </div>
                                        <span className="mt-4">
                                            <a className="me-3 text-secondary" href="">Dismiss</a>
                                            <a className="text-d-underline" href="">Upgrade plan</a>
                                        </span>
                                    </div>
                                </div>
                                <div className="app-divider-v"></div>
                                <div className="d-flex align-items-center">
                                    <span className="h-45 w-45 d-flex-center bg-warning b-r-50 position-relative">
                                        <img alt="avtar" className="img-fluid b-r-50"
                                            src="../assets/images/avtar/9.png" />
                                        <span
                                            className="position-absolute top-0 end-0 p-1 bg-success border border-light rounded-circle"></span>
                                    </span>
                                    <div className="flex-grow-1 ps-2 log-out-profile">
                                        <div className="f-w-600 fs-6"> {name}</div>
                                        <div className="text-secondary f-s-12">{role}</div>
                                    </div>
                                    <div>
                                        <a href="{handlelogut}">
                                            <span>
                                                <i className="ph-bold  ph-arrow-square-out f-s-20"></i>
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-8 col-xxl-9">
                        {/* ✅ User Profile Header - shows on every tab */}
<div className="card mb-3">
    <div className="card-body">
        <div className="d-flex align-items-center gap-3">
            <div
                style={{
                    width: "65px",
                    height: "65px",
                    borderRadius: "50%",
                    backgroundImage: `url(${
                        data?.profile_pic && data.profile_pic.trim() !== ""
                            ? `https://api.mokshiq.in/media/${data.profile_pic}`
                            : "../assets/images/avtar/9.png"
                    })`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    border: "3px solid var(--bs-primary)",
                    flexShrink: 0,
                }}
            />
            <div className="flex-grow-1">
                <h5 className="mb-0 f-w-600">{data?.name || "N/A"}</h5>
                <p className="mb-0 text-secondary f-s-13">{data?.email || ""}</p>
                <div className="d-flex align-items-center gap-2 mt-1 flex-wrap">
                    {data?.shop_name && (
                        <span className="text-secondary f-s-13">
                            <i className="ph ph-buildings me-1"></i>{data.shop_name}
                        </span>
                    )}
                    {data?.mobile && (
                        <span className="text-secondary f-s-13">
                            <i className="ph ph-phone me-1"></i>{data.mobile}
                        </span>
                    )}
                </div>
            </div>
            <div className="text-end d-none d-sm-block">
                <span className={`badge f-s-12 px-3 py-2 ${
                    data?.kyc_status === "active"
                        ? "text-light-success"
                        : data?.kyc === "pending"
                        ? "text-light-warning"
                        : "text-light-danger"
                }`}>
                    <i className={`ph-fill me-1 ${
                        data?.kyc === "active"
                            ? "ph-check-circle text-success"
                            : data?.kyc === "pending"
                            ? "ph-clock text-warning"
                            : "ph-x-circle text-danger"
                    }`}></i>
                    KYC {data?.kyc || "Pending"}
                </span>
            </div>
        </div>
    </div>
</div>

                        <div className="tab-content">
                            {/* Profile Tab */}
                            <div aria-labelledby="profile-tab" className="tab-pane fade active show"
                                id="profile-tab-pane" role="tabpanel" tabIndex="0">
                                <div className="card setting-profile-tab">
                                    <div className="card-header">
                                        <h5>Profile</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="profile-tab profile-container">
                                            <div className="image-details">
                                                <div
                                                    className="profile-image"
                                                    style={{
                                                        backgroundImage: `url(${data?.profile_pic
                                                                ? `https://api.mokshiq.in/media//${data.profile_pic}`
                                                                : "../assets/css/d9205813a3d4ae4d299c.jpg"
                                                            })`,
                                                    }}
                                                ></div>
                                                <div className="profile-pic">
                                                    <div className="avatar-upload">
                                                        <div className="avatar-edit">
                                                            <input accept=".png, .jpg, .jpeg" id="imageUpload"
                                                                type="file" />
                                                            <label htmlFor="imageUpload"><i
                                                                className="ti ti-photo-heart"></i></label>
                                                        </div>
                                                        <div className="avatar-preview">
                                                            <div id="imgPreview" style={{
                                                                backgroundImage: `url(https://api.mokshiq.in/media//${data.profile_pic})`,
                                                            }}>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="person-details">
                                                <h5 className="f-w-600">{data.name}
                                                    <img alt="instagram-check-mark" height="20"
                                                        src="../assets/images/profile-app/01.png"
                                                        width="20" />
                                                </h5>
                                                <p>{data.shop_name}</p>
                                            </div>

                                            {/* ✅ key forces remount with latest data after save */}
                                            <form key={`profile-${dataVersion}`} className="app-form" onSubmit={handleProfileUpdate}>
                                                <h5 className="mb-2 text-dark f-w-600">User Info</h5>
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="mb-3">
                                                            <input type="hidden" name="id" defaultValue={effectiveUserId} />
                                                            <input type="hidden" name="action" defaultValue={"profile_update"} />
                                                            <label className="form-label">Username</label>
                                                            <input className="form-control" placeholder="Maria C. Eck"
                                                                type="text" name="name" defaultValue={data?.name || ""} />
                                                            {getErrorMessage('profile', 'name') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('profile', 'name')}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="mb-3">
                                                            <label className="form-label">Email address</label>
                                                            <input className="form-control"
                                                                placeholder="MariaCEck@teleworm.us"
                                                                type="email" name="email" defaultValue={data?.email || ""} />
                                                            {getErrorMessage('profile', 'email') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('profile', 'email')}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="mb-3">
                                                            <label className="form-label">Phone</label>
                                                            <input className="form-control" placeholder=""
                                                                type="text" name="mobile" defaultValue={data?.mobile || ""} />
                                                            {getErrorMessage('profile', 'mobile') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('profile', 'mobile')}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="app-divider-v dotted"></div>
                                                    </div>
                                                    <h5 className="mb-2 text-dark f-w-600">Personal Info</h5>
                                                    <div className="col-12">
                                                        <div className="mb-3">
                                                            <label className="form-label">Address</label>
                                                            <textarea className="form-control"
                                                                placeholder="1098 Asylum Avenu New Haven, CT 06510" 
                                                                name="address" defaultValue={data?.address || ""}></textarea>
                                                            {getErrorMessage('profile', 'address') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('profile', 'address')}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label" htmlFor="inputCity">City</label>
                                                            <input className="form-control" id="inputCity"
                                                                placeholder="oregon" type="text" name="city" defaultValue={data?.city || ""} />
                                                            {getErrorMessage('profile', 'city') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('profile', 'city')}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="mb-3">
                                                            <label className="form-label" htmlFor="inputState">State</label>
                                                            <input className="form-control" id="inputState"
                                                                placeholder="oregon" type="text" name="state" defaultValue={data?.state || ""} />
                                                            {getErrorMessage('profile', 'state') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('profile', 'state')}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="mb-3">
                                                            <label className="form-label" htmlFor="inputZip">Zip</label>
                                                            <input className="form-control" id="inputZip"
                                                                placeholder="CT 06510" type="text" name="pin_code" defaultValue={data?.pincode || ""} />
                                                            {getErrorMessage('profile', 'pin_code') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('profile', 'pin_code')}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-xl-4">
                                                        <div className="">
                                                            <label className="form-label">language</label>
                                                            <select className="select-langauge form-select select-basic" name="language">
                                                                <option value="EN">English</option>
                                                                <option value="GU">Gujarati</option>
                                                                <option value="HI">Hindi</option>
                                                                <option value="DU">Dutch</option>
                                                                <option value="FR">French</option>
                                                                <option value="RU">Russian</option>
                                                                <option value="KO">Korean</option>
                                                                <option value="TA">Tamil</option>
                                                                <option value="SP">Spanish</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="text-end">
                                                            <button className="btn btn-primary" type="submit" 
                                                                disabled={isFormLoading('profile')}>
                                                                {isFormLoading('profile') ? 'Updating...' : 'Submit'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* KYC Details Tab */}
                            <div aria-labelledby="activity-tab" className="tab-pane fade" id="activity-tab-pane"
                                role="tabpanel" tabIndex="0">
                                <div className="card equal-card month-timeline">
                                    <div className="card-header">
                                        <div className="activity-time">
                                            <h5>KYC Details</h5>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content" id="OutlineContent">
                                            <div aria-labelledby="today-tab" className="tab-pane fade show active"
                                                id="today-tab-pane" role="tabpanel" tabIndex="0">
                                                {/* ✅ key forces remount with latest data after save */}
                                                <form key={`kyc-${dataVersion}`} onSubmit={handleKycUpdate}>
                                                    <h5 className="mb-2 text-dark f-w-600">Document Info</h5>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="mb-3">
                                                                <label className="form-label">Shop Name</label>
                                                                <input className="form-control" placeholder="Maria C. Eck"
                                                                    type="text" name="shop_name" defaultValue={data?.shop_name || ""} />
                                                                {getErrorMessage('kyc', 'shop_name') && (
                                                                    <span className="text-danger f-s-12">{getErrorMessage('kyc', 'shop_name')}</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="mb-3">
                                                                <label className="form-label">GST Number</label>
                                                                <input className="form-control"
                                                                    placeholder="22AAAAA0000A1Z5"
                                                                    type="text" name="gstin" defaultValue={data?.gst_num || ""} />
                                                                {getErrorMessage('kyc', 'gstin') && (
                                                                    <span className="text-danger f-s-12">{getErrorMessage('kyc', 'gstin')}</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="mb-3">
                                                                <label className="form-label">Pancard Number</label>
                                                                <input className="form-control" placeholder="AAAAA0000A"
                                                                    type="text" name="pan_card" defaultValue={data?.pan_card || ""} />
                                                                {getErrorMessage('kyc', 'pan_card') && (
                                                                    <span className="text-danger f-s-12">{getErrorMessage('kyc', 'pan_card')}</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="mb-3">
                                                                <label className="form-label">Aadhar Number</label>
                                                                <input className="form-control" placeholder="123456789012"
                                                                    type="text" name="aadhar_card" defaultValue={data?.aadhar_num || ""} />
                                                                {getErrorMessage('kyc', 'aadhar_card') && (
                                                                    <span className="text-danger f-s-12">{getErrorMessage('kyc', 'aadhar_card')}</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="app-divider-v dotted"></div>
                                                        </div>
                                                        <h5 className="mb-2 text-dark f-w-600">Upload Documents</h5>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">Aadhar card front</label>
                                                                    <input className="form-control" type="file" name="aadharfront" accept=".jpg,.jpeg,.png,.pdf" />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">Aadhar card back</label>
                                                                    <input className="form-control" type="file" name="aadharback" accept=".jpg,.jpeg,.png,.pdf" />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">Pancard</label>
                                                                    <input className="form-control" type="file" name="pan" accept=".jpg,.jpeg,.png,.pdf" />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">GST Document</label>
                                                                    <input className="form-control" type="file" name="gst" accept=".jpg,.jpeg,.png,.pdf" />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">Profile Pic</label>
                                                                    <input className="form-control" type="file" name="profile" accept=".jpg,.jpeg,.png,.pdf" />
                                                                </div>
                                                            </div>
                                                            <div className="col-12">
                                                                <div className="app-divider-v dotted"></div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="text-end">
                                                                <button className="btn btn-primary" type="submit"
                                                                    disabled={isFormLoading('kyc')}>
                                                                    {isFormLoading('kyc') ? 'Updating...' : 'Submit'}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>

                                                <ul className="app-timeline-box activity-timeline">
                                                    <li className="timeline-section">
                                                        <div className="timeline-icon">
                                                            <span className="text-light-info h-35 w-35 d-flex-center b-r-50 icon-direction">
                                                                <i className="ph-duotone  ph-image f-s-18"></i>
                                                            </span>
                                                        </div>
                                                        <div className="timeline-content">
                                                            <p className=" f-s-16 text-info mb-0">Uploaded Documents</p>
                                                            <div className="app-timeline-info-text timeline-border-box me-2 ms-0 mt-3 p-3">
                                                                <div className="row">
                                                                    <div className="col-sm-4">
                                                                        <a className="glightbox img-hover-zoom"
                                                                            data-glightbox="type: image; zoomable: true;"
                                                                            href={ data?.aadhar_front && data.aadhar_front.trim() !== ""
      ? `https://api.mokshiq.in/media/${data.aadhar_front}`
      :"../assets/images/draggable/02.jpg"}>
                                                                            <img alt="" className="w-100 rounded" src={ data?.aadhar_front && data.aadhar_front.trim() !== ""
      ? `https://api.mokshiq.in/media/${data.aadhar_front}`
      :"../assets/images/draggable/02.jpg" }/>
                                                                        </a>
                                                                    </div>
                                                                    <div className="col-sm-4">
                                                                        <a className="glightbox img-hover-zoom"
                                                                            data-glightbox="type: image; zoomable: true;"
                                                                            href={ data?.aadhar_back && data.aadhar_back.trim() !== ""
                                                                                ? `https://api.mokshiq.in/media/${data.aadhar_back}`
                                                                                :"../assets/images/draggable/04.jpg"}>
                                                                            <img alt="" className="w-100 rounded" src={ data?.aadhar_back && data.aadhar_back.trim() !== ""
      ? `https://api.mokshiq.in/media/${data.aadhar_back}`
      :"../assets/images/draggable/04.jpg"} />
                                                                        </a>
                                                                    </div>
                                                                    <div className="col-sm-4">
                                                                        <a className="glightbox img-hover-zoom"
                                                                            data-glightbox="type: image; zoomable: true;"
                                                                            href={ data?.pan_card_pic && data.pan_card_pic.trim() !== ""
                                                                                ? `https://api.mokshiq.in/media/${data.pan_card_pic}`
                                                                                :"../assets/images/draggable/04.jpg"}>
                                                                            <img alt="" className="w-100 rounded" src={ data?.pan_card_pic && data.pan_card_pic.trim() !== ""
                                                                                ? `https://api.mokshiq.in/media/${data.pan_card_pic}`
                                                                                :"../assets/images/draggable/04.jpg"}/>
                                                                        </a>
                                                                    </div>
                                                                    <div className="col-sm-4">
                                                                        <a className="glightbox img-hover-zoom"
                                                                            data-glightbox="type: image; zoomable: true;"
                                                                            href={ data?.profile_pic && data.profile_pic.trim() !== ""
                                                                                ? `https://api.mokshiq.in/media/${data.profile_pic}`
                                                                                :"../assets/images/draggable/04.jpg"}>
                                                                            <img alt="" className="w-100 rounded" src={ data?.profile_pic && data.profile_pic.trim() !== ""
                                                                                ? `https://api.mokshiq.in/media/${data.profile_pic}`
                                                                                :"../assets/images/draggable/04.jpg"}/>
                                                                        </a>
                                                                    </div>
                                                                    <div className="col-sm-4">
                                                                        <a className="glightbox img-hover-zoom"
                                                                            data-glightbox="type: image; zoomable: true;"
                                                                            href={ data?.gst_pic && data.gst_pic.trim() !== ""
                                                                                ? `https://api.mokshiq.in/media/${data.gst_pic}`
                                                                                :"../assets/images/draggable/04.jpg"}>
                                                                            <img alt="" className="w-100 rounded" src={ data?.gst_pic && data.gst_pic.trim() !== ""
                                                                                ? `https://api.mokshiq.in/media/${data.gst_pic}`
                                                                                :"../assets/images/draggable/04.jpg"}/>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <p className="f-w-500 mt-2 mb-0">
                                                                <i className="ph ph-clock me-1 align-middle"></i>Updated at 12:45 pm
                                                            </p>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Password Manager Tab */}
                            <div aria-labelledby="security-tab" className="tab-pane fade" id="security-tab-pane"
                                role="tabpanel" tabIndex="0">
                                <div className="card security-card-content">
                                    <div className="card-body">
                                        <div className="account-security">
                                            <div className="row align-items-center">
                                                <div className="col-sm-8">
                                                    <h5 className="text-primary f-w-600">Account Security</h5>
                                                    <p className=" account-discription text-secondary f-s-16 mt-2 mb-0">
                                                        your account is valuable to hackers. to make 2-step verification very secure, use
                                                        your phone's built-in security key</p>
                                                </div>
                                                <div className="col-sm-4 account-security-img">
                                                    <img alt="" className="w-180" src="../assets/images/setting-app/account.png" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card security-card-content">
                                    <div className="card-body">
                                        <div className="account-security">
                                            <div className="row align-items-center">
                                                <div className="col-sm-9">
                                                    <h5 className="text-primary f-w-600">Devices and active sessions</h5>
                                                    <p className="account-discription text-secondary f-s-16 mt-3">
                                                        your account is valuable to hackers. to make 2-step verification very secure, use
                                                        your phone's built-in security key</p>
                                                </div>
                                                <div className="col-sm-3 account-security-img">
                                                    <img alt="" className="w-150" src="../assets/images/setting-app/device.png" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-12 col-xxl-6">
                                        <ul className="active-device-session active-device-list" id="shareMenuLeft">
                                            <li>
                                                <div className="card share-menu-active">
                                                    <div className="card-body">
                                                        <div className="device-menu-item" draggable="false">
                                                            <span className="device-menu-img">
                                                                <i className="ph-duotone  ph-laptop f-s-40 text-success"></i>
                                                            </span>
                                                            <div className="device-menu-content">
                                                                <h6 className="mb-0 txt-ellipsis-1">Apple Mac 10.15.7</h6>
                                                                <p className="mb-0 txt-ellipsis-1 text-secondary">
                                                                    switzerland 201.36.24.108</p>
                                                            </div>
                                                            <div className="device-menu-icons">
                                                                <span className="badge text-light-secondary p-2 f-s-16">
                                                                    <i className="ph-fill  ph-check-circle me-1 text-success"></i>Online</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="card">
                                                    <div className="card-body">
                                                        <div className="device-menu-item " draggable="false">
                                                            <span className="device-menu-img">
                                                                <i className="ph-duotone  ph-device-mobile f-s-40 text-primary"></i>
                                                            </span>
                                                            <div className="device-menu-content">
                                                                <h6 className="mb-0 txt-ellipsis-1">Apple Iphone ios 15.0.2</h6>
                                                                <p className="mb-0 txt-ellipsis-1 text-secondary">Ukrain 176.38.19.14</p>
                                                            </div>
                                                            <div className="device-menu-icons">
                                                                <span className="badge text-light-secondary p-2 f-s-16">
                                                                    <i className="ph-fill  ph-x-circle me-1 text-primary"></i>Offline</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-lg-12 col-xxl-6">
                                        <ul className="active-device-session  active-device-list" id="shareMenuRight">
                                            <li>
                                                <div className="card">
                                                    <div className="card-body">
                                                        <div className="device-menu-item " draggable="false">
                                                            <span className="device-menu-img">
                                                                <i className="ph-duotone  ph-device-mobile f-s-40 text-primary"></i>
                                                            </span>
                                                            <div className="device-menu-content">
                                                                <h6 className="mb-0 txt-ellipsis-1">Apple Mac 10.15.7</h6>
                                                                <p className="mb-0 txt-ellipsis-1 text-secondary">Amerika 201.136.24.108</p>
                                                            </div>
                                                            <div className="device-menu-icons">
                                                                <span className="badge text-light-secondary p-2 f-s-16">
                                                                    <i className="ph-fill  ph-x-circle me-1 text-primary"></i>Offline</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="card security-card-content">
                                    <div className="card-body">
                                        <div className="account-security mb-2">
                                            <div className="row align-items-center">
                                                <div className="col-sm-9">
                                                    <h5 className="text-primary f-w-600">Change Password</h5>
                                                    <p className="account-discription text-secondary f-s-16 mt-3">To change your password,
                                                        please fill in the fields below. your password must contain at least 8 character, it must also include at
                                                        least one upper case letter, one lower case letter, one number and one special character.</p>
                                                </div>
                                                <div className="col-sm-3 account-security-img">
                                                    <img alt="" className="w-150" src="../assets/images/setting-app/password.png" />
                                                </div>
                                            </div>
                                        </div>

                                        <form className="app-form" onSubmit={handlePasswordChange}>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                <input type="hidden" name="user_id" defaultValue={effectiveUserId} />
                                                    <label className="form-label" htmlFor="currentPassword">Current Password</label>
                                                    <div className="input-group input-group-password mb-3">
                                                        <span className="input-group-text b-r-left"><i className="ph-bold  ph-lock f-s-20"></i></span>
                                                        <input aria-label="Amount (to the nearest dollar)"
                                                            className="form-control" id="currentPassword" placeholder="********"
                                                            type="password" name="current_password" />
                                                        <span className="input-group-text b-r-right">
                                                            <i className="ph ph-eye-slash f-s-20 eyes-icon" onClick={(e) => {
                                                                const input = e.target.closest('.input-group').querySelector('input');
                                                                const icon = e.target;
                                                                if (input.type === 'password') {
                                                                    input.type = 'text';
                                                                    icon.className = 'ph ph-eye f-s-20 eyes-icon';
                                                                } else {
                                                                    input.type = 'password';
                                                                    icon.className = 'ph ph-eye-slash f-s-20 eyes-icon';
                                                                }
                                                            }}></i>
                                                        </span>
                                                    </div>
                                                    {getErrorMessage('password', 'current_password') && (
                                                        <span className="text-danger f-s-12">{getErrorMessage('password', 'current_password')}</span>
                                                    )}
                                                </div>
                                                <div className="col-sm-12">
                                                    <label className="form-label" htmlFor="newPassword">New Password</label>
                                                    <div className="input-group input-group-password mb-3">
                                                        <span className="input-group-text b-r-left"><i className="ph-bold  ph-lock f-s-20"></i></span>
                                                        <input aria-label="Amount (to the nearest dollar)"
                                                            className="form-control" id="password" placeholder="********"
                                                            type="password" name="password" />
                                                        <span className="input-group-text b-r-right">
                                                            <i className="ph ph-eye-slash f-s-20 eyes-icon" onClick={(e) => {
                                                                const input = e.target.closest('.input-group').querySelector('input');
                                                                const icon = e.target;
                                                                if (input.type === 'password') {
                                                                    input.type = 'text';
                                                                    icon.className = 'ph ph-eye f-s-20 eyes-icon';
                                                                } else {
                                                                    input.type = 'password';
                                                                    icon.className = 'ph ph-eye-slash f-s-20 eyes-icon';
                                                                }
                                                            }}></i>
                                                        </span>
                                                    </div>
                                                    {getErrorMessage('password', 'password') && (
                                                        <span className="text-danger f-s-12">{getErrorMessage('password', 'password')}</span>
                                                    )}
                                                </div>
                                                <div className="col-sm-12">
                                                    <label className="form-label" htmlFor="confirmPassword">Confirm Password</label>
                                                    <div className="input-group input-group-password mb-3">
                                                        <span className="input-group-text b-r-left"><i className="ph-bold  ph-lock f-s-20"></i></span>
                                                        <input aria-label="Amount (to the nearest dollar)"
                                                            className="form-control" id="confirmPassword" placeholder="********"
                                                            type="password" name="confirm_password" />
                                                        <span className="input-group-text b-r-right">
                                                            <i className="ph ph-eye-slash f-s-20 eyes-icon" onClick={(e) => {
                                                                const input = e.target.closest('.input-group').querySelector('input');
                                                                const icon = e.target;
                                                                if (input.type === 'password') {
                                                                    input.type = 'text';
                                                                    icon.className = 'ph ph-eye f-s-20 eyes-icon';
                                                                } else {
                                                                    input.type = 'password';
                                                                    icon.className = 'ph ph-eye-slash f-s-20 eyes-icon';
                                                                }
                                                            }}></i>
                                                        </span>
                                                    </div>
                                                    {getErrorMessage('password', 'confirm_password') && (
                                                        <span className="text-danger f-s-12">{getErrorMessage('password', 'confirm_password')}</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="text-end">
                                                    <button className="btn btn-primary" type="submit"
                                                        disabled={isFormLoading('password')}>
                                                        {isFormLoading('password') ? 'Updating...' : 'Submit'}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>

                            {/* PIN Manager Tab */}
                            <div aria-labelledby="privacy-tab" className="tab-pane fade" id="privacy-tab-pane"
                                role="tabpanel" tabIndex="0">
                                <div className="card equal-card privacy-card">
                                    <div className="card-header">
                                        <h5>PIN Manager</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="card security-card-content">
                                            <div className="card-body">
                                                <div className="account-security mb-2">
                                                    <div className="row align-items-center">
                                                        <div className="col-sm-9">
                                                            <h5 className="text-primary f-w-600">Change MPIN</h5>
                                                            <p className="account-discription text-secondary f-s-16 mt-3">To change your MPIN,
                                                                please fill in the fields below. Your MPIN must be 4-6 digits for security purposes.</p>
                                                        </div>
                                                        <div className="col-sm-3 account-security-img">
                                                            <img alt="" className="w-150" src="../assets/images/setting-app/password.png" />
                                                        </div>
                                                    </div>
                                                </div>

                                                <form className="app-form" onSubmit={getOtp ? handlePinChange : sendOTP}>
                                                    <div className="row">
                                                        <div className="col-sm-12">
                                                            <label className="form-label" htmlFor="newPin">New PIN</label>
                                                            <div className="input-group input-group-password mb-3">
                                                                <span className="input-group-text b-r-left"><i className="ph-bold  ph-lock f-s-20"></i></span>
                                                                <input aria-label="Amount (to the nearest dollar)"
                                                                    className="form-control" id="newPin" placeholder="1234"
                                                                    type="password" name="new_pin" maxLength="6" />
                                                                <span className="input-group-text b-r-right">
                                                                    <i className="ph ph-eye-slash f-s-20 eyes-icon" onClick={(e) => {
                                                                        const input = e.target.closest('.input-group').querySelector('input');
                                                                        const icon = e.target;
                                                                        if (input.type === 'password') {
                                                                            input.type = 'text';
                                                                            icon.className = 'ph ph-eye f-s-20 eyes-icon';
                                                                        } else {
                                                                            input.type = 'password';
                                                                            icon.className = 'ph ph-eye-slash f-s-20 eyes-icon';
                                                                        }
                                                                    }}></i>
                                                                </span>
                                                            </div>
                                                            {getErrorMessage('pin', 'new_pin') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('pin', 'new_pin')}</span>
                                                            )}
                                                        </div>
                                                        <div className="col-sm-12">
                                                            <label className="form-label" htmlFor="confirmPin">Confirm PIN</label>
                                                            <div className="input-group input-group-password mb-3">
                                                                <span className="input-group-text b-r-left"><i className="ph-bold  ph-lock f-s-20"></i></span>
                                                                <input aria-label="Amount (to the nearest dollar)"
                                                                    className="form-control" id="confirmPin" placeholder="1234"
                                                                    type="password" name="confirm_pin" maxLength="6" />
                                                                <span className="input-group-text b-r-right">
                                                                    <i className="ph ph-eye-slash f-s-20 eyes-icon" onClick={(e) => {
                                                                        const input = e.target.closest('.input-group').querySelector('input');
                                                                        const icon = e.target;
                                                                        if (input.type === 'password') {
                                                                            input.type = 'text';
                                                                            icon.className = 'ph ph-eye f-s-20 eyes-icon';
                                                                        } else {
                                                                            input.type = 'password';
                                                                            icon.className = 'ph ph-eye-slash f-s-20 eyes-icon';
                                                                        }
                                                                    }}></i>
                                                                </span>
                                                            </div>
                                                            {getErrorMessage('pin', 'confirm_pin') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('pin', 'confirm_pin')}</span>
                                                            )}
                                                        </div>
                                                        <div className="col-sm-12">
                                                            <label className="form-label" htmlFor="otpPin">OTP</label>
                                                            <div className="input-group input-group-password mb-3">
                                                                <span className="input-group-text b-r-left"><i className="ph-bold  ph-lock f-s-20"></i></span>
                                                                <input aria-label="Amount (to the nearest dollar)"
                                                                    className="form-control" id="otpPin" placeholder="123456"
                                                                    type="text" name="otp" maxLength="6" />
                                                            </div>
                                                            {getErrorMessage('pin', 'otp') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('pin', 'otp')}</span>
                                                            )}
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="text-end">
                                                                <button className="btn btn-primary" type="submit"
                                                                    disabled={isFormLoading('pin')}>
                                                                    {getOtp ? isFormLoading('pin') ? 'Updating...' : 'Submit' : "Send OTP"}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Bank Details Tab */}
                            <div aria-labelledby="subscription-tab" className="tab-pane fade" id="subscription-tab-pane"
                                role="tabpanel" tabIndex="0">
                                <div className="card">
                                    <div className="card-header">
                                        <h5>Bank Details</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="card security-card-content">
                                            <div className="card-body">
                                                <div className="account-security mb-2">
                                                    <div className="row align-items-center">
                                                        <div className="col-sm-9">
                                                            <h5 className="text-primary f-w-600">Add Bank Details</h5>
                                                            <p className="account-discription text-secondary f-s-16 mt-3">Admins can add or update a user's bank account information. Ensure that the account holder's name, account number, IFSC code, and bank name are entered correctly. Accurate details are required to enable smooth fund transfers, refunds, and other financial transactions.</p>
                                                        </div>
                                                        <div className="col-sm-3 account-security-img">
                                                            <img alt="" className="w-150" src="../assets/images/setting-app/password.png" />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* ✅ key forces remount with latest data after save */}
                                                <form key={`bank-${dataVersion}`} className="app-form" onSubmit={handleBankDetailsUpdate}>
                                                    <div className="row">
                                                        <div className="col-sm-12">
                                                        <input type="hidden" name="id" defaultValue={effectiveUserId} />
                                                        <input type="hidden" name="action" defaultValue={"bank_update"} />
                                                        <input type="hidden" name="holder_naame" defaultValue={data.name} />
                                                            <label className="form-label" htmlFor="accountNumber">Account Number</label>
                                                            <div className="input-group input-group-password mb-3">
                                                                <span className="input-group-text b-r-left"><i className="ph-bold  ph-identification-card f-s-20"></i></span>
                                                                <input aria-label="Amount (to the nearest dollar)"
                                                                    className="form-control" id="accountNumber" placeholder="enter account number" defaultValue={data.account_number}
                                                                    type="text" name="account_number" />
                                                            </div>
                                                            {getErrorMessage('bank', 'account_number') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('bank', 'account_number')}</span>
                                                            )}
                                                        </div>
                                                        <div className="col-sm-12">
                                                            <label className="form-label" htmlFor="bankName">Bank Name</label>
                                                            <div className="input-group input-group-password mb-3">
                                                                <span className="input-group-text b-r-left"><i className="ph-bold  ph-bank f-s-20"></i></span>
                                                                <input aria-label="Amount (to the nearest dollar)"
                                                                    className="form-control" id="bankName" placeholder="enter bank name"
                                                                    type="text" name="bank_name" defaultValue={data.bank_name}/>
                                                            </div>
                                                            {getErrorMessage('bank', 'bank_name') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('bank', 'bank_name')}</span>
                                                            )}
                                                        </div>
                                                        <div className="col-sm-12">
                                                            <label className="form-label" htmlFor="ifscCode">IFSC Code</label>
                                                            <div className="input-group input-group-password mb-3">
                                                                <span className="input-group-text b-r-left"><i className="ph-bold  ph-code f-s-20"></i></span>
                                                                <input aria-label="Amount (to the nearest dollar)"
                                                                    className="form-control" id="ifscCode" placeholder="enter ifsc code"
                                                                    type="text" name="bank_ifsc" defaultValue={data.ifsc_code} />
                                                            </div>
                                                            {getErrorMessage('bank', 'bank_ifsc') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('bank', 'bank_ifsc')}</span>
                                                            )}
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="text-end">
                                                                <button className="btn btn-primary" type="submit"
                                                                    disabled={isFormLoading('bank')}>
                                                                    {isFormLoading('bank') ? 'Updating...' : 'Submit'}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Role Manager Tab */}
                            <div aria-labelledby="Connection-tab" className="tab-pane fade" id="Connection-tab-pane"
                                role="tabpanel" tabIndex="0">
                                <div className="card">
                                    <div className="card-header">
                                        <h5>Role Manager</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="card security-card-content">
                                            <div className="card-body">
                                                <div className="account-security mb-2">
                                                    <div className="row align-items-center">
                                                        <div className="col-sm-9">
                                                            <h5 className="text-primary f-w-600">Assign Role</h5>
                                                            <p className="account-discription text-secondary f-s-16 mt-3">As an admin, you can assign specific roles to users based on their responsibilities. Roles determine access levels, permissions, and available features within the system. Select the appropriate role carefully to ensure proper authorization and security.</p>
                                                        </div>
                                                        <div className="col-sm-3 account-security-img">
                                                            <img alt="" className="w-150" src="../assets/images/setting-app/password.png" />
                                                        </div>
                                                    </div>
                                                </div>

                                                <form className="app-form" onSubmit={handleRoleAssignment}>
                                                    <div className="row">
                                                        <div className="col-sm-12">
                                                            <label className="form-label" htmlFor="roleSelect">Select Role</label>
                                                            <select className="form-select w-100" name="role" id="roleSelect">
                                                                <option value="">Choose a role</option>
                                                                <option value="5">Retailer</option>
                                                                <option value="4">Distributor</option>
                                                                <option value="3">Super Distributor</option>
                                                                <option value="2">White label</option>
                                                            </select>
                                                            {getErrorMessage('role', 'role') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('role', 'role')}</span>
                                                            )}
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="text-end mt-3">
                                                                <button className="btn btn-primary" type="submit"
                                                                    disabled={isFormLoading('role')}>
                                                                    {isFormLoading('role') ? 'Updating...' : 'Submit'}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Mapping Manager Tab */}
                            <div aria-labelledby="mapping-manager-tab" className="tab-pane fade" id="mapping-manager-tab-pane"
                                role="tabpanel" tabIndex="0">
                                <div className="card">
                                    <div className="card-header">
                                        <h5>Mapping Manager</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="card-body">
                                            <div className="account-security mb-2">
                                                <div className="row align-items-center">
                                                    <div className="col-sm-9">
                                                        <h5 className="text-primary f-w-600">Manage mapping</h5>
                                                        <p className="account-discription text-secondary f-s-16 mt-3">As an admin, you can reassign or change a user's mapping under another member or company. Use this option to ensure users are linked to the correct hierarchy for reporting, access, and transactions. All changes should be reviewed carefully before saving, as they directly impact account structure and permissions.</p>
                                                    </div>
                                                    <div className="col-sm-3 account-security-img">
                                                        <img alt="" className="w-150" src="../assets/images/setting-app/password.png" />
                                                    </div>
                                                </div>
                                            </div>

                                            <form className="app-form" onSubmit={handleMappingUpdate}>
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <label className="form-label" htmlFor="memberSelect">Select Member</label>
                                                        <select className="form-select w-100" name="member" id="memberSelect" onChange={handleRoleChange}> 
                                                            <option value="">Choose a member</option>
                                                            <option value="5">Retailer</option>
                                                            <option value="4">Distributor</option>
                                                            <option value="3">Super Distributor</option>
                                                            <option value="2">White label</option>
                                                        </select>
                                                        {getErrorMessage('mapping', 'member') && (
                                                            <span className="text-danger f-s-12">{getErrorMessage('mapping', 'member')}</span>
                                                        )}
                                                    </div>
                                                   {/* SEARCHABLE DROPDOWN */}
    {role && (
        <div className="mb-3 position-relative">
            <label>Search Member</label>
            <input
                type="text"
                className="form-control"
                placeholder="Type name or mobile..."
                value={search}
                onChange={handleSearch}
                onFocus={() => setShowDropdown(true)}
            />
            {showDropdown && (
                <div 
                    className="dropdown-menu show w-100"
                    style={{ maxHeight: "200px", overflowY: "auto" }}
                >
                    {filtered.length > 0 ? (
                        filtered.map((m) => (
                            <div
                                key={m.id}
                                className="dropdown-item"
                                onClick={() => handleSelect(m)}
                                style={{ cursor: "pointer" }}
                            >
                                {m.name} ({m.mobile})
                            </div>
                        ))
                    ) : (
                        <div className="dropdown-item text-muted">
                            No users found
                        </div>
                    )}
                </div>
            )}
        </div>
    )}
                                                    <div className="col-12">
                                                        <div className="text-end mt-3">
                                                            <button className="btn btn-primary" type="submit"
                                                                disabled={isFormLoading('mapping')}>
                                                                {isFormLoading('mapping') ? 'Updating...' : 'Submit'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Update KYC Tab */}
                            <div aria-labelledby="update-kyc-tab" className="tab-pane fade" id="update-kyc-tab-pane"
                                role="tabpanel" tabIndex="0">
                                <div className="card equal-card privacy-card">
                                    <div className="card-header">
                                        <h5>Update KYC</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="card security-card-content">
                                            <div className="card-body">
                                                <div className="account-security mb-2">
                                                    <div className="row align-items-center">
                                                        <div className="col-sm-9">
                                                            <h5 className="text-primary f-w-600">Update KYC From Admin</h5>
                                                            <p className="account-discription text-secondary f-s-16 mt-3">As an admin, you can update or verify a customer's KYC details. Ensure that all uploaded documents (ID proof, address proof, and photo) are valid, legible, and meet compliance requirements before approval.</p>
                                                        </div>
                                                        <div className="col-sm-3 account-security-img">
                                                            <img alt="" className="w-150" src="../assets/images/setting-app/password.png" />
                                                        </div>
                                                    </div>
                                                </div>

                                                <form className="app-form" onSubmit={handleKycStatusUpdate}>
                                                    <div className="row">
                                                        <div className="col-sm-12">
                                                        <input type="hidden" name="user_id" defaultValue={effectiveUserId} />
                                                            <input type="hidden" name="action" defaultValue={"UpdateKYC"} />
                                                            <label className="form-label" htmlFor="kycStatusSelect">KYC Status</label>
                                                            <select className="form-select w-100" name="kyc_status" id="kycStatusSelect">
                                                                <option value="">Choose status</option>
                                                                <option value="active">Active</option>
                                                                <option value="pending">Pending</option>
                                                                <option value="reject">Reject</option>
                                                            </select>
                                                            {getErrorMessage('kycStatus', 'kyc_status') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('kycStatus', 'kyc_status')}</span>
                                                            )}
                                                        </div>
                                                        <div className="col-sm-12">
                                                            <label className="form-label" htmlFor="userStatusSelect">User Status</label>
                                                            <select className="form-select w-100" name="user_status" id="userStatusSelect">
                                                                <option value="">Choose status</option>
                                                                <option value="active">Active</option>
                                                                <option value="pending">Pending</option>
                                                                <option value="reject">Reject</option>
                                                            </select>
                                                            {getErrorMessage('kycStatus', 'user_status') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('kycStatus', 'user_status')}</span>
                                                            )}
                                                        </div>
                                                        <div className="col-sm-12">
                                                            <label className="form-label" htmlFor="kycRemarks">Remarks</label>
                                                            <div className="input-group input-group-password mb-3">
                                                                <span className="input-group-text b-r-left"><i className="ph-bold  ph-chat-text f-s-20"></i></span>
                                                                <input aria-label="Amount (to the nearest dollar)"
                                                                    className="form-control" id="kycRemarks" placeholder="Type message here."
                                                                    type="text" name="remark" />
                                                            </div>
                                                            {getErrorMessage('kycStatus', 'remark') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('kycStatus', 'remark')}</span>
                                                            )}
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="text-end">
                                                                <button className="btn btn-primary" type="submit"
                                                                    disabled={isFormLoading('kycStatus')}>
                                                                    {isFormLoading('kycStatus') ? 'Updating...' : 'Submit'}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Fund Transfer Tab */}
                            <div aria-labelledby="fund-transfer-tab" className="tab-pane fade" id="fund-transfer-tab-pane"
                                role="tabpanel" tabIndex="0">
                                <div className="card equal-card privacy-card">
                                    <div className="card-header">
                                        <h5>Fund Transfer/Returns</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="card security-card-content">
                                            <div className="card-body">
                                                <div className="account-security mb-2">
                                                    <div className="row align-items-center">
                                                        <div className="col-sm-9">
                                                            <h5 className="text-primary f-w-600">Release Fund</h5>
                                                            <p className="account-discription text-secondary f-s-16 mt-3">To initiate a fund transfer or return, please fill in the required details below. Ensure that the information provided is accurate, including the recipient account details and transaction amount. Once submitted, the transaction will be processed securely, and you will receive a confirmation.</p>
                                                        </div>
                                                        <div className="col-sm-3 account-security-img">
                                                            <img alt="" className="w-150" src="../assets/images/setting-app/password.png" />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* ── Wallet Balance Cards ── */}
<div className="row mb-4">
    <div className="col-md-6 mb-2">
        <div className="card hover-effect card-light-primary mb-0">
            <div className="card-body d-flex align-items-center justify-content-between">
                <div>
                    <p className="mb-1 text-secondary f-s-13 f-w-500">Main Wallet</p>
                    <h4 className="mb-0 f-w-700 text-primary">
                        ₹ {data?.wallet_balance !== undefined && data?.wallet_balance !== null
                            ? parseFloat(data.wallet_balance).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            : "0.00"}
                    </h4>
                </div>
                <span className="h-50 w-50 d-flex-center bg-primary b-r-50">
                    <i className="ph-duotone ph-wallet f-s-26 text-white"></i>
                </span>
            </div>
        </div>
    </div>
    <div className="col-md-6 mb-2">
        <div className="card hover-effect card-light-success mb-0">
            <div className="card-body d-flex align-items-center justify-content-between">
                <div>
                    <p className="mb-1 text-secondary f-s-13 f-w-500">Credit Wallet</p>
                    <h4 className="mb-0 f-w-700 text-success">
                        ₹ {data?.nwallet_balance !== undefined && data?.nwallet_balance !== null
                            ? parseFloat(data.nwallet_balance).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            : "0.00"}
                    </h4>
                </div>
                <span className="h-50 w-50 d-flex-center bg-success b-r-50">
                    <i className="ph-duotone ph-credit-card f-s-26 text-white"></i>
                </span>
            </div>
        </div>
    </div>
</div>
                                                <form className="app-form" onSubmit={handleFundTransfer}>
                                                    <div className="row">
                                                        <div className="col-sm-12">
                                                            <label className="form-label" htmlFor="transactionTypeSelect">Transaction Type</label>
                                                            <select className="form-select w-100" name="transaction_type" id="transactionTypeSelect" onChange={(e) => setSelectedTxnType(e.target.value)} value={selectedTxnType}>
                                                                <option value="">Choose transaction type</option>
                                                                <option value="TRANSFER">Transfer</option>
                                                                <option value="RETURN">Return</option>
                                                            </select>
                                                            {getErrorMessage('fundTransfer', 'transaction_type') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('fundTransfer', 'transaction_type')}</span>
                                                            )}
                                                        </div>
                                                        {/* ── Wallet Type: only visible for RETURN ── */}
                                                       
                                                            <div className="col-sm-12 mt-2">
                                                                <label className="form-label" htmlFor="walletTypeSelect">Return From</label>
                                                                <select
                                                                    className="form-select w-100"
                                                                    name="wallet_type"
                                                                    id="walletTypeSelect"
                                                                    defaultValue="CREDIT"
                                                                >
                                                                    <option value="CREDIT">Credit Wallet (correction only)</option>
                                                                     {selectedTxnType === "RETURN" && (
                                                                    <option value="MAIN">Main Wallet (deduct from me, add to target)</option>
                                                                     )}
                                                                    <option value="MAIN_WALLET">AEPS Wallet</option>
                                                                </select>
                                                                {getErrorMessage('fundTransfer', 'wallet_type') && (
                                                                    <span className="text-danger f-s-12">{getErrorMessage('fundTransfer', 'wallet_type')}</span>
                                                                )}
                                                            </div>
                                                        
                                                       
                                                        <div className="col-sm-12">
                                                            <label className="form-label" htmlFor="amountInput">Amount</label>
                                                            <div className="input-group input-group-password mb-3">
                                                                <span className="input-group-text b-r-left"><i className="ph-bold  ph-currency-inr f-s-20"></i></span>
                                                                <input aria-label="Amount (to the nearest dollar)"
                                                                    className="form-control" id="amountInput" placeholder="Enter amount"
                                                                    type="number" name="amount" min="1" step="0.01" />
                                                            </div>
                                                            {getErrorMessage('fundTransfer', 'amount') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('fundTransfer', 'amount')}</span>
                                                            )}
                                                        </div>
                                                        <div className="col-sm-12">
                                                            <label className="form-label" htmlFor="transactionPin">Transaction PIN</label>
                                                            <div className="input-group input-group-password mb-3">
                                                                <span className="input-group-text b-r-left"><i className="ph-bold  ph-lock f-s-20"></i></span>
                                                                <input aria-label="Amount (to the nearest dollar)"
                                                                    className="form-control" id="transactionPin" placeholder="0000"
                                                                    type="password" name="transaction_pin" maxLength="6" />
                                                            </div>
                                                            {getErrorMessage('fundTransfer', 'transaction_pin') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('fundTransfer', 'transaction_pin')}</span>
                                                            )}
                                                        </div>
                                                        <div className="col-sm-12">
                                                            <label className="form-label" htmlFor="transferRemarks">Remarks</label>
                                                            <div className="input-group input-group-password mb-3">
                                                                <span className="input-group-text b-r-left"><i className="ph-bold  ph-chat-text f-s-20"></i></span>
                                                                <input aria-label="Amount (to the nearest dollar)"
                                                                    className="form-control" id="transferRemarks" placeholder="Type message here."
                                                                    type="text" name="remarks" />
                                                            </div>
                                                            {getErrorMessage('fundTransfer', 'remarks') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('fundTransfer', 'remarks')}</span>
                                                            )}
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="text-end">
                                                                <button className="btn btn-primary" type="submit"
                                                                    disabled={isFormLoading('fundTransfer')}>
                                                                    {isFormLoading('fundTransfer') ? 'Processing...' : 'Submit'}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Notification Tab */}
                            <div aria-labelledby="notification-tab" className="tab-pane fade" id="notification-tab-pane"
                                role="tabpanel" tabIndex="0">
                                <div className="card">
                                    <div className="card-header">
                                        <h5>Notification</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="notification-content">
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="notification-email">
                                                        <h6>By Email</h6>
                                                        <div className="select-item">
                                                            <input className="form-check-input form-check-primary w-25 h-25"
                                                                id="checkbox-email" type="checkbox" value="option1" />
                                                            <label className="form-check-label" htmlFor="checkbox-email">
                                                                <span className="d-flex align-items-center position-relative">
                                                                    <span className="ms-3 privacy-content">
                                                                        <span className="mb-0 text-dark txt-ellipsis-1 f-s-16 f-w-500">Comments</span>
                                                                        <span className="text-secondary mb-0"> notified posts on comment</span>
                                                                    </span>
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div className="select-item">
                                                            <input className="form-check-input form-check-primary w-25 h-25"
                                                                id="checkbox-email1" type="checkbox" value="option2" />
                                                            <label className="form-check-label" htmlFor="checkbox-email1">
                                                                <span className="d-flex align-items-center">
                                                                    <span className="ms-3 privacy-content">
                                                                        <span className="mb-0 text-dark txt-ellipsis-1 f-s-16 f-w-500">Candidates</span>
                                                                        <span className="text-secondary mb-0"> notified candidate applies </span>
                                                                    </span>
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div className="select-item">
                                                            <input className="form-check-input form-check-primary w-25 h-25"
                                                                id="checkbox-email2" type="checkbox" value="option3" />
                                                            <label className="form-check-label" htmlFor="checkbox-email2">
                                                                <span className="d-flex align-items-center">
                                                                    <span className="ms-3 privacy-content">
                                                                        <span className="mb-0 text-dark txt-ellipsis-1 f-s-16 f-w-500">Offers</span>
                                                                        <span className="text-secondary mb-0"> notified accepts or rejects</span>
                                                                    </span>
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mt-lg-0 mt-3">
                                                    <div className="notification-push">
                                                        <h6 className="mb-0">Push Notification</h6>
                                                        <p className="mb-0">This are delivered via sms to your mobile phone.</p>
                                                        <div className="d-flex align-items-center gap-1 mt-3">
                                                            <input className="form-check-input form-check-primary f-s-18 mb-1 m-1"
                                                                id="radio_default1" name="flexRadioDefault" type="radio" />
                                                            <label className="form-check-label" htmlFor="radio_default1">
                                                                <span className="mb-0 f-s-16 f-w-500"> Everything </span>
                                                            </label>
                                                        </div>
                                                        <div className="d-flex align-items-center gap-1 mt-3">
                                                            <input className="form-check-input form-check-primary f-s-18 mb-1 m-1"
                                                                id="radio_default2" name="flexRadioDefault" type="radio" />
                                                            <label className="form-check-label" htmlFor="radio_default2">
                                                                <span className="mb-0 f-s-16 f-w-500"> Same as a email</span>
                                                            </label>
                                                        </div>
                                                        <div className="d-flex align-items-center gap-1 mt-3">
                                                            <input className="form-check-input form-check-primary f-s-18 mb-1 m-1"
                                                                id="radio_default3" name="flexRadioDefault" type="radio" />
                                                            <label className="form-check-label" htmlFor="radio_default3">
                                                                <span className="mb-0 f-s-16 f-w-500"> No push notification</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="app-divider-v"></div>

                                            <div className="col-12">
                                                <ul className="notified-contet share-menu-list">
                                                    <li>
                                                        <div className="share-menu-item mb-4">
                                                            <span className="share-menu-img text-outline-primary h-45 w-45 d-flex-center b-r-10">
                                                                <i className="ph-bold  ph-device-mobile-speaker f-s-30"></i>
                                                            </span>
                                                            <div className="share-menu-content">
                                                                <h6 className="mb-0 txt-ellipsis-1">Mobile push notification</h6>
                                                                <p className="mb-0 txt-ellipsis-1 text-secondary">
                                                                    Receive the all notifications via your mobile app</p>
                                                            </div>
                                                            <div className="form-check form-switch d-flex mt-1">
                                                                <input checked className="form-check-input  form-check-primary ms-3 fs-3 me-3"
                                                                    id="basic-switch-6" type="checkbox" />
                                                                <label className="form-check-label pt-2" htmlFor="basic-switch-6"></label>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="share-menu-item mb-4">
                                                            <span className="share-menu-img text-outline-success h-45 w-45 d-flex-center b-r-10">
                                                                <i className="ph-bold  ph-desktop f-s-30"></i>
                                                            </span>
                                                            <div className="share-menu-content">
                                                                <h6 className="mb-0 txt-ellipsis-1">desktop push notification</h6>
                                                                <p className="mb-0 txt-ellipsis-1 text-secondary">
                                                                    Receive the all notifications via your desktop app</p>
                                                            </div>
                                                            <div className="form-check form-switch d-flex mt-1">
                                                                <input checked className="form-check-input  form-check-primary ms-3 fs-3 me-3"
                                                                    id="basic-switch-4" type="checkbox" />
                                                                <label className="form-check-label pt-2" htmlFor="basic-switch-4"></label>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="share-menu-item mb-4">
                                                            <span className="share-menu-img text-outline-danger h-45 w-45 d-flex-center b-r-10">
                                                                <i className="ph-bold  ph-watch f-s-30"></i>
                                                            </span>
                                                            <div className="share-menu-content">
                                                                <h6 className="mb-0 txt-ellipsis-1">Smartwatch push notification</h6>
                                                                <p className="mb-0  txt-ellipsis-1 text-secondary">
                                                                    Receive the all notifications via your smartwatch app</p>
                                                            </div>
                                                            <div className="form-check form-switch d-flex mt-1">
                                                                <input checked className="form-check-input  form-check-primary ms-3 fs-3 me-3"
                                                                    id="basic-switch-5" type="checkbox" />
                                                                <label className="form-check-label pt-2" htmlFor="basic-switch-5"></label>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Scheme Manager Tab */}
                            <div aria-labelledby="scheme-manager-tab" className="tab-pane fade" id="scheme-manager-tab-pane"
                                role="tabpanel" tabIndex="0">
                               <div className="card">
                                    <div className="card-header">
                                        <h5>Scheme Manager</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="card security-card-content">
                                            <div className="card-body">
                                                <div className="account-security mb-2">
                                                    <div className="row align-items-center">
                                                        <div className="col-sm-9">
                                                            <h5 className="text-primary f-w-600">Assign New Scheme</h5>
                                                            <p className="account-discription text-secondary f-s-16 mt-3">As an admin, you can assign specific scheme to users based on their commercial. Scheme determine commission and chanrge levels, and available features within the system. Select the appropriate scheme carefully to ensure proper commission.</p>
                                                        </div>
                                                        <div className="col-sm-3 account-security-img">
                                                            <img alt="" className="w-150" src="../assets/images/setting-app/password.png" />
                                                        </div>
                                                    </div>
                                                </div>

                                                <form className="app-form" onSubmit={handleSchemeAssignment}>
                                                    <div className="row">
                                                        <div className="col-sm-12">
                                                            <label className="form-label" htmlFor="roleSelect">Select Scheme</label>
                                                            <select className="form-select w-100" name="scheme_id" id="roleSelect">
                                                            <option value="">Choose a Scheme</option>
  {schemeData.map((scheme) => (
    <option key={scheme.id} value={scheme.id}>
      {scheme.Name}
    </option>
  ))}
                                                            </select>
                                                            {getErrorMessage('scheme_id', 'scheme_id') && (
                                                                <span className="text-danger f-s-12">{getErrorMessage('scheme_id', 'scheme_id')}</span>
                                                            )}
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="text-end mt-3">
                                                                <button className="btn btn-primary" type="submit"
                                                                    disabled={isFormLoading('role')}>
                                                                    {isFormLoading('role') ? 'Updating...' : 'Submit'}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                           {/* Permission Manager Tab */}
<div aria-labelledby="permission-manager-tab" className="tab-pane fade" id="permission-manager-tab-pane"
    role="tabpanel" tabIndex="0">
    <div className="card equal-card privacy-card">
        <div className="card-header">
            <h5>Permission Manager</h5>
        </div>
        <div className="card-body">
            <div className="account-security mb-2">
                <div className="row align-items-center">
                    <div className="col-sm-9">
                        <h5 className="text-primary f-w-600">Manage Service Permissions</h5>
                        <p className="account-discription text-secondary f-s-16 mt-3">
                            Assign or revoke service access for this user. Only services 
                            available in your account can be assigned to sub-users.
                        </p>
                    </div>
                    <div className="col-sm-3 account-security-img">
                        <img alt="" className="w-150" src="../assets/images/setting-app/password.png" />
                    </div>
                </div>
            </div>

            {permissionMemberId ? (
                <PermissionManager
                    memberId={permissionMemberId}
                    onClose={() => setPermissionMemberId(null)}
                />
            ) : (
                <div className="text-center py-4">
                    <i className="ph-duotone ph-shield-lock f-s-48 text-primary mb-3 d-block"></i>
                    <p className="text-secondary mb-3">
                        Click below to manage service permissions for this user.
                    </p>
                    <button
                        className="btn btn-primary"
                        onClick={() => setPermissionMemberId(effectiveUserId)}
                    >
                        <i className="ph-bold ph-lock-open me-2"></i>
                        Manage Permissions
                    </button>
                </div>
            )}
        </div>
    </div>
</div>


{/* Wallet Actions Tab */}
<div aria-labelledby="wallet-actions-tab" className="tab-pane fade" id="wallet-actions-tab-pane"
    role="tabpanel" tabIndex="0">
    <div className="card equal-card privacy-card">
        <div className="card-header">
            <h5>Wallet Actions</h5>
        </div>
        <div className="card-body">
            <div className="card security-card-content">
                <div className="card-body">
                    <div className="account-security mb-2">
                        <div className="row align-items-center">
                            <div className="col-sm-9">
                                <h5 className="text-primary f-w-600">Hold / Unhold / Chargeback</h5>
                                <p className="account-discription text-secondary f-s-16 mt-3">
                                    Perform advanced wallet operations. Use <strong>Hold</strong> to freeze funds,
                                    <strong> Unhold</strong> to release them, <strong>Chargeback</strong> to deduct
                                    disputed funds, and <strong>Reimburse Chargeback</strong> to reverse a chargeback.
                                </p>
                            </div>
                            <div className="col-sm-3 account-security-img">
                                <img alt="" className="w-150" src="../assets/images/setting-app/password.png" />
                            </div>
                        </div>
                    </div>

                    {/* Wallet Balance Cards */}
                    <div className="row mb-4">
                        <div className="col-md-4 mb-2">
                            <div className="card hover-effect card-light-primary mb-0">
                                <div className="card-body d-flex align-items-center justify-content-between">
                                    <div>
                                        <p className="mb-1 text-secondary f-s-13 f-w-500">Main Wallet</p>
                                        <h4 className="mb-0 f-w-700 text-primary">
                                            ₹ {data?.wallet_balance !== undefined
                                                ? parseFloat(data.wallet_balance).toLocaleString('en-IN', { minimumFractionDigits: 2 })
                                                : "0.00"}
                                        </h4>
                                    </div>
                                    <span className="h-50 w-50 d-flex-center bg-primary b-r-50">
                                        <i className="ph-duotone ph-wallet f-s-26 text-white"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mb-2">
                            <div className="card hover-effect card-light-warning mb-0">
                                <div className="card-body d-flex align-items-center justify-content-between">
                                    <div>
                                        <p className="mb-1 text-secondary f-s-13 f-w-500">Hold Amount</p>
                                        <h4 className="mb-0 f-w-700 text-warning">
                                            ₹ {data?.hold_amount !== undefined
                                                ? parseFloat(data.hold_amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })
                                                : "0.00"}
                                        </h4>
                                    </div>
                                    <span className="h-50 w-50 d-flex-center bg-warning b-r-50">
                                        <i className="ph-duotone ph-lock-simple f-s-26 text-white"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mb-2">
                            <div className="card hover-effect card-light-danger mb-0">
                                <div className="card-body d-flex align-items-center justify-content-between">
                                    <div>
                                        <p className="mb-1 text-secondary f-s-13 f-w-500">Chargeback Amount</p>
                                        <h4 className="mb-0 f-w-700 text-danger">
                                            ₹ {data?.charge_amount !== undefined
                                                ? parseFloat(data.charge_amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })
                                                : "0.00"}
                                        </h4>
                                    </div>
                                    <span className="h-50 w-50 d-flex-center bg-danger b-r-50">
                                        <i className="ph-duotone ph-arrow-u-up-left f-s-26 text-white"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Action Info Badges */}
                    <div className="row mb-4">
                        {[
                            { action: "HOLD", color: "warning", icon: "ph-lock-simple", desc: "Freeze funds from wallet → hold pool" },
                            { action: "UNHOLD", color: "success", icon: "ph-lock-open", desc: "Release funds from hold → back to wallet" },
                            { action: "CHARGEBACK", color: "danger", icon: "ph-arrow-u-up-left", desc: "Deduct disputed funds → chargeback pool" },
                            { action: "REIMBURSE_CHARGEBACK", color: "info", icon: "ph-arrow-counter-clockwise", desc: "Reverse chargeback → restore to wallet" },
                        ].map(({ action, color, icon, desc }) => (
                            <div className="col-md-6 mb-2" key={action}>
                                <div
                                    className={`card mb-0 border-${color} ${selectedWalletAction === action ? `bg-light-${color}` : ''}`}
                                    style={{ cursor: 'pointer', border: `1.5px solid var(--bs-${color})` }}
                                    onClick={() => setSelectedWalletAction(action)}
                                >
                                    <div className="card-body py-2 px-3 d-flex align-items-center gap-2">
                                        <i className={`ph-duotone ${icon} f-s-22 text-${color}`}></i>
                                        <div>
                                            <p className={`mb-0 f-w-600 f-s-14 text-${color}`}>{action.replace('_', ' ')}</p>
                                            <p className="mb-0 text-secondary f-s-12">{desc}</p>
                                        </div>
                                        {selectedWalletAction === action && (
                                            <i className={`ph-fill ph-check-circle ms-auto text-${color} f-s-18`}></i>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <form className="app-form" onSubmit={handleWalletAction}>
                        <div className="row">
                            <div className="col-sm-12">
                                <label className="form-label">Action Type</label>
                                <select
                                    className="form-select w-100"
                                    name="wallet_action"
                                    value={selectedWalletAction}
                                    onChange={(e) => setSelectedWalletAction(e.target.value)}
                                >
                                    <option value="">Choose action</option>
                                    <option value="HOLD">HOLD – Freeze wallet funds</option>
                                    <option value="UNHOLD">UNHOLD – Release held funds</option>
                                    <option value="CHARGEBACK">CHARGEBACK – Deduct disputed amount</option>
                                    <option value="REIMBURSE_CHARGEBACK">REIMBURSE_CHARGEBACK – Reverse chargeback</option>
                                </select>
                                {getErrorMessage('walletAction', 'wallet_action') && (
                                    <span className="text-danger f-s-12">{getErrorMessage('walletAction', 'wallet_action')}</span>
                                )}
                            </div>

                            <div className="col-sm-12 mt-2">
                                <label className="form-label">Wallet Type</label>
                                <select
                                    className="form-select w-100"
                                    name="wallet_type_action"
                                    value={walletActionWalletType}
                                    onChange={(e) => setWalletActionWalletType(e.target.value)}
                                >
                                    <option value="WALLET">Main Wallet (wallet_ammount)</option>
                                    <option value="MAIN_WALLET">AEPS Wallet (main_wallet)</option>
                                </select>
                                {getErrorMessage('walletAction', 'wallet_type_action') && (
                                    <span className="text-danger f-s-12">{getErrorMessage('walletAction', 'wallet_type_action')}</span>
                                )}
                            </div>

                            {/* Contextual hint */}
                            {selectedWalletAction && (
                                <div className="col-sm-12 mt-2">
                                    <div className={`alert alert-${
                                        selectedWalletAction === 'HOLD' ? 'warning' :
                                        selectedWalletAction === 'UNHOLD' ? 'success' :
                                        selectedWalletAction === 'CHARGEBACK' ? 'danger' : 'info'
                                    } py-2 f-s-13`}>
                                        {selectedWalletAction === 'HOLD' &&
                                            `Deducts from ${walletActionWalletType === 'MAIN_WALLET' ? 'AEPS Wallet' : 'Main Wallet'} and adds to Hold pool.`}
                                        {selectedWalletAction === 'UNHOLD' &&
                                            `Releases from Hold pool back to ${walletActionWalletType === 'MAIN_WALLET' ? 'AEPS Wallet' : 'Main Wallet'}.`}
                                        {selectedWalletAction === 'CHARGEBACK' &&
                                            `Deducts from ${walletActionWalletType === 'MAIN_WALLET' ? 'AEPS Wallet' : 'Main Wallet'} and moves to Chargeback pool.`}
                                        {selectedWalletAction === 'REIMBURSE_CHARGEBACK' &&
                                            `Releases from Chargeback pool back to ${walletActionWalletType === 'MAIN_WALLET' ? 'AEPS Wallet' : 'Main Wallet'}.`}
                                    </div>
                                </div>
                            )}

                            <div className="col-sm-12 mt-2">
                                <label className="form-label">Amount</label>
                                <div className="input-group mb-3">
                                    <span className="input-group-text b-r-left">
                                        <i className="ph-bold ph-currency-inr f-s-20"></i>
                                    </span>
                                    <input
                                        className="form-control"
                                        placeholder="Enter amount"
                                        type="number"
                                        name="amount_action"
                                        min="1"
                                        step="0.01"
                                    />
                                </div>
                                {getErrorMessage('walletAction', 'amount_action') && (
                                    <span className="text-danger f-s-12">{getErrorMessage('walletAction', 'amount_action')}</span>
                                )}
                            </div>

                            <div className="col-sm-12">
                                <label className="form-label">Remark</label>
                                <div className="input-group mb-3">
                                    <span className="input-group-text b-r-left">
                                        <i className="ph-bold ph-chat-text f-s-20"></i>
                                    </span>
                                    <input
                                        className="form-control"
                                        placeholder="Reason for this action..."
                                        type="text"
                                        name="remark_action"
                                    />
                                </div>
                                {getErrorMessage('walletAction', 'remark_action') && (
                                    <span className="text-danger f-s-12">{getErrorMessage('walletAction', 'remark_action')}</span>
                                )}
                            </div>

                            <div className="col-12">
                                <div className="text-end">
                                    <button
                                        className="btn btn-primary"
                                        type="submit"
                                        disabled={isFormLoading('walletAction')}
                                    >
                                        {isFormLoading('walletAction') ? 'Processing...' : 'Submit'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
                        </div>
                    </div>
                </div>
            </div>
            {permissionMemberId && (
  <PermissionManager
    memberId={permissionMemberId}
    onClose={() => setPermissionMemberId(null)}
  />
)}
        </main>
    );
}

export default MemberSettingManagement;